import * as bannerActions from '../banner/banner.actions';
import { BannerState } from './banner.state';

export type Action = bannerActions.All;

const defaultState: BannerState = {
    loading: false,
    bannersCMS: []
};

export function BannerReducer(state = defaultState, action: any) {
    switch (action.type) {
        case bannerActions.DO_GET_HEADERS:
            return {
                ...state,
                loading: true
            };

        case bannerActions.DO_GET_HEADERS_OK:
            return {
                ...state,
                loading: false,
                bannersCMS: action.payload
            };

        case bannerActions.DO_GET_HEADERS_KO:
            return {
                ...state,
                loading: false,
                bannersCMS: []
            };
        default:
            return state;
    }
}
